import { TelLink } from "./reqLinks";

// 법령 머리의 분야별 연락처 — law.go.kr 원문 오른쪽 위에 나오는 "부처 (분야 - 과), 전화" 목록 그대로(문의 #77).
// 연락처가 둘 이상인 법령에만 실린다. 대표 전화 한 줄은 호출부가 종전대로 보인다.
export default function AgencyContactList({ contacts, compact = false }) {
  if (!Array.isArray(contacts) || contacts.length === 0) return null;
  return (
    <div
      data-testid="agency-contact-list"
      style={{
        margin: compact ? "4px 0 0" : "0 0 12px",
        fontSize: compact ? 11.5 : 12.5,
        lineHeight: 1.7,
        color: "var(--audit-text)",
      }}
    >
      {!compact && (
        <div style={{ fontSize: 11.5, fontWeight: 700, color: "var(--audit-text-muted)" }}>
          분야별 문의처 {contacts.length}곳
        </div>
      )}
      {contacts.map((c, i) => (
        <div key={`${c.dept}-${c.tel}-${i}`} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <span style={{ color: "var(--audit-text-muted)" }}>{c.ministry}</span>
          {c.dept && <span>{c.dept}</span>}
          <TelLink tel={c.tel} />
        </div>
      ))}
    </div>
  );
}
